<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="3">
          <b-button v-b-modal.modal-filter-TranscationLog variant="primary">
            <feather-icon icon="FilterIcon" class="mr-25" />
            <span>Filter</span>
          </b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3" />
        <b-col md="3">
          <b-form-input v-model="filter" type="search" placeholder="search" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            striped
            :items="items"
            :fields="fields"
            :filter="filter"
            :per-page="perPage"
            :current-page="currentPage"
            caption-top
            :responsive="true"
          >
            <template #table-caption>
              <h2>Transaction Log history</h2>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
          />
        </b-col>
      </b-row>

      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
    <b-col>
      <b-modal
        id="modal-filter-TranscationLog"
        ref="modal"
        hide-footer
        title="Filter Tarnsaction Log"
        size="lg"
      >
        <validation-observer ref="simpleRules">
          <form ref="form" @submit.stop.prevent="filterTransactionLog">
            <b-row>
              <b-col md="6">
                <b-form-group label="Order Code" label-for="orderCode">
                  <b-form-input
                    id="orderCode-input"
                    v-model="filterForm.orderCode"
                    placeholder="orderCode"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Message Type" label-for="messageType">
                  <validation-provider
                    #default="{ errors }"
                    name="messageType"
                    rules="required"
                  >
                    <b-form-select
                      id="input-3"
                      v-model="filterForm.messageType"
                      :options="filterForm.messageTypeOptions"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Payment Status" label-for="paymentStatus">
                  <validation-provider
                    #default="{ errors }"
                    name="paymentStatus"
                    rules="required"
                  >
                    <b-form-select
                      id="paymentStatus input-3"
                      v-model="filterForm.paymentStatus"
                      :options="paymentStatusOptions"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Transaction Date Range"
                  label-for="transactionDateRange"
                >
                  <flat-pickr
                    v-model="transactionDateRange"
                    class="form-control"
                    :config="{ mode: 'range' }"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Payment option" label-for="paymentOption">
                  <validation-provider
                    #default="{ errors }"
                    name="paymentOption"
                    rules="required"
                  >
                    <b-form-select
                      id="paymentOption input-3"
                      v-model="filterForm.paymentOption"
                      :options="paymentOptionOptions"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="Message Direction"
                  label-for="messageDirection"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="messageDirection"
                    rules="required"
                  >
                    <b-form-select
                      id="paymentOption input-3"
                      v-model="filterForm.messageDirection"
                      :options="messageDirectionOptions"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-button
              variant="primary"
              type="submit"
              @click.prevent="filterTransactionLog"
            >
              Filter
            </b-button>
          </form>
        </validation-observer>
      </b-modal>
    </b-col>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BTable,
  BPagination,
  BCard,
  BOverlay,
  BButton,
  BFormGroup,
  BFormSelect,
} from "bootstrap-vue";
import { required } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import axios from "@axios";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BTable,
    BPagination,
    BCard,
    BOverlay,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormSelect,
    flatPickr,
  },
  data() {
    return {
      required,
      isLoading: false,
      props: ["items"],
      fields: [
        "orderCode",
        "paymentOptionDescription",
        "messageDirectionDescription",
        "messageTypeDescription",
        "transactionDate",
      ],
      items: [],
      filter: "",
      perPage: 10,
      currentPage: 1,
      transactionDateRange: "",
      filterForm: {
        orderCode: "",
        fromDate: "",
        toDate: "",
        toPaidDate: "",
        messageType: 0,
        partnerType: 0,
        paymentStatus: 0,
        paymentOption: 0,
        messageDirection: 0,
        messageTypeOptions: [
          { value: 0, text: "All" },
          { value: 1, text: "ConfirmPayment" },
          { value: 2, text: "FetchOrder" },
          { value: 3, text: "OrderRequest" },
        ],
      },
      paymentStatusOptions: [
        { value: 0, text: "All" },
        { value: 1, text: "Pending" },
        { value: 2, text: "Approved" },
        { value: 3, text: "Canceled" },
        { value: 4, text: "Error" },
        { value: 5, text: "Unauthorized" },
        { value: 6, text: "Rejected" },
        { value: 7, text: "Redirected" },
        { value: 8, text: "RefundSubmitted" },
        { value: 9, text: "RefundPending" },
        { value: 10, text: "RefundApproved" },
        { value: 11, text: "RefundSent" },
        { value: 12, text: "RefundRejected" },
        { value: 13, text: "RefundCompleted" },
      ],
      paymentOptionOptions: [
        { value: 0, text: "Default" },
        { value: 1, text: "CBEBranch" },
        { value: 2, text: "CBEBirr" },
        { value: 3, text: "Amole" },
        { value: 4, text: "PSS" },
        { value: 5, text: "United" },
        { value: 6, text: "Abyssinia" },
        { value: 7, text: "CBEMobile" },
      ],
      messageDirectionOptions: [
        { value: 0, text: "All" },
        { value: 1, text: "OutGoing" },
        { value: 2, text: "Incoming" },
      ],
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    this.fetchData().catch((error) => {
      console.error(error);
    });
  },
  methods: {
    filterTransactionLog() {
      // this.$refs.simpleRules.validate().then(success => {
      //   if (success) {
      this.$refs.modal.hide();
      this.isLoading = true;
      const [from, to] = this.transactionDateRange.split(" to ");
      this.filterForm.fromDate = from;
      this.filterForm.toDate = to;

      if (this.transactionDateRange.includes("to")) {
        this.filterForm.fromDate = from;
        this.filterForm.toDate = to;
      } else {
        this.filterForm.fromDate = this.transactionDateRange;
        this.filterForm.toDate = this.transactionDateRange;
      }

      axios
        .get(
          `/Monitor/api/V1.0/Monitor/FilterTransactionLogHistories?customOrderCode=${this.filterForm.orderCode}&paymentStatus=${this.filterForm.paymentStatus}&paymentOption=${this.filterForm.paymentOption}&paidDate=${this.filterForm.toPaidDate}&fromDate=${this.filterForm.fromDate}&ToDate=${this.filterForm.toDate}`
        )
        .then((res) => {
          this.isLoading = false;
          console.log(res);
          this.items = res.orderTransactionHistories;
        })
        .catch((res) => {
          this.isLoading = false;
          console.log(res);
          this.$bvModal.msgBoxOk(`${res.data.message}`, {
            title: "Error",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
        });
      //   }
      // })
    },
    fetchData() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Transaction-View");
      axios
        .get("/Monitor/api/V1.0/Monitor/GetTransactionLogHistories")
        .then((res) => {
          this.items = res.orderTransactionHistories;
          this.isLoading = false;
        })
        .catch((res) => {
          console.log(res);
          this.isLoading = false;
          this.$bvModal.msgBoxOk(res.data.message, {
            title: "Error",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
